import React from 'react'
import TranslateText from 'translation/TranslateText';

function InventoryHeader() {
    return (
        <div className="page-header-container">
          <div
            className="page-header section-dark"
            style={{
              backgroundImage: `url(${require("assets/img/creditcard.jpg")})`,
            }}
          >
            <div className="centered">
          <h1 className='age inq'><TranslateText text="Tradeline Inventory" /></h1>
        </div>
           
          </div>
          
        </div>
    );
}

export default InventoryHeader